/**
 * Centralized React Query keys for the rentals feature.
 * Mirrors the pattern used in src/features/calendar (CALENDAR_EVENTS_QUERY_KEYS).
 */
import type { RentalItemsFilters } from "@/features/rentals/types/rentals.type";

export const RENTALS_QUERY_KEYS = {
  collections: ["rentals", "collections"] as const,
  collection: (id: string | undefined) => ["rentals", "collection", id] as const,
  items: (filters?: RentalItemsFilters) =>
    ["rentals", "items", filters ?? {}] as const,
  item: (id: string | undefined) => ["rentals", "item", id] as const,
  // Le cart unifié (Phase 1+) est cache-key dédié pour pouvoir
  // l'invalider depuis le booking create/cancel sans toucher la
  // liste des items.
  cart: ["rentals", "cart", "current"] as const,
  availableCheckInDates: (itemId: string | undefined) =>
    ["rentals", "item", itemId, "available-check-in-dates"] as const,
  availableCheckOutDates: (itemId: string | undefined, checkInDate: string | undefined) =>
    ["rentals", "item", itemId, "available-check-out-dates", checkInDate] as const,
  // Hors du préfixe `item` : le quota porte sur toute la collection, une
  // réservation sur un autre article le fait bouger. On invalide donc tout
  // le préfixe `seasonQuotaUsageAll` à chaque réservation créée ou retirée.
  seasonQuotaUsageAll: ["rentals", "season-quota-usage"] as const,
  seasonQuotaUsage: (itemId: string | undefined) =>
    ["rentals", "season-quota-usage", itemId] as const,
  myBookings: ["rentals", "bookings", "mine"] as const,
  booking: (id: string | undefined) => ["rentals", "booking", id] as const,
  accountStatement: ["rentals", "account-statement"] as const,
  categoriesForCollection: (collectionId: string | undefined) =>
    ["rentals", "categories", collectionId ?? "all"] as const,
};

export const RENTALS_STALE_TIME = 60 * 1000;
export const RENTALS_LONG_STALE_TIME = 5 * 60 * 1000;
